module.exports = __webpack_public_path__ + "img/welcome.7e30272d.png";